import React, { useState } from "react";
import { Link } from "react-router-dom";

const buttonStyle = {
  fontSize: 18,
  padding: "8px 24px",
  borderRadius: 6,
  border: "2px solid #3182ce",
  background: "#fff",
  color: "#3182ce",
  fontWeight: 600,
  cursor: "pointer",
  transition: "background 0.2s, color 0.2s",
  marginLeft: 8,
};
const primaryStyle = {
  ...buttonStyle,
  background: "#3182ce",
  color: "#fff",
};
const dropdownItemStyle = {
  fontSize: 15,
  padding: "6px 18px",
  borderRadius: 4,
  border: "none",
  background: "#f7fafc",
  color: "#3182ce",
  fontWeight: 500,
  cursor: "pointer",
  margin: "2px 0",
  display: "block",
};

export default function MenuHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", padding: "24px 32px 0 24px", gap: 16, position: "relative" }}>
      <button
        style={buttonStyle}
        onClick={() => setMenuOpen(open => !open)}
        id="menu-btn"
      >
        Menu ▾
      </button>
      {menuOpen && (
        <div style={{
          position: "absolute",
          top: 48,
          right: 120,
          background: "#fff",
          border: "1px solid #3182ce",
          borderRadius: 8,
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          minWidth: 160,
          zIndex: 10,
          padding: "8px 0",
          display: "flex",
          flexDirection: "column"
        }}>
          <Link to="/subscribe" style={dropdownItemStyle} onClick={() => setMenuOpen(false)}>Subscriptions</Link>
          <Link to="/specialised" style={dropdownItemStyle} onClick={() => setMenuOpen(false)}>Specialised Collections</Link>
          <Link to="/about" style={dropdownItemStyle} onClick={() => setMenuOpen(false)}>About Us</Link>
          <Link to="/contact" style={dropdownItemStyle} onClick={() => setMenuOpen(false)}>Contact</Link>
        </div>
      )}
      <Link to="/login" style={buttonStyle}>Login</Link>
      <Link to="/signup" style={primaryStyle}>Sign Up</Link>
    </div>
  );
}
